<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	.scopefont {
		color: #fff;
		width: 80%;
		margin: 0 auto;
		border-radius: 1px;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		// text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div ref="homes">
		<titles titlename="课程列表管理" titlecontent="这里可以看到课程列表管理" :mbx="paths"></titles>
		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入课程名称" v-model="input" clearable></el-input></div>
			</div>

			<div class="sclectlable">
				<div><el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
			</div>

			<div class="primarybtn"><el-button @click="getname()" type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column :resizable="false" label="专业" width="140" prop="pro_name">
								<template slot-scope="scope">
									<p :title="scope.row.pro_name" style="width: 100%;">{{ scope.row.pro_name }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="创建者" width="100" prop="CO_Creator">
								<template slot-scope="scope">
									<p :title="scope.row.CO_Creator" style="text-align: center;width: 100%;">{{ scope.row.CO_Creator }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="课程名称" prop="CO_CoursesName">
								<template slot-scope="scope">
									<p :title="scope.row.CO_CoursesName" style="width: 100%;">{{ scope.row.CO_CoursesName }}</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="封面图片" width="220">
								<template slot-scope="scope">
									<img :src="scope.row.CO_CoverImgUrl" style="width: 185px;height: 120px;border-radius: 5px;" alt="" />
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="创建时间" width="160" prop="CO_CreationTime"></el-table-column>
							<el-table-column :resizable="false" label="权限" width="140">
								<template slot-scope="scope">
									<p>
										{{
											scope.row.CO_Privilage == 1
												? '对本院校公开'
												: scope.row.CO_Privilage == 0
												? '所有登录用户公开'
												: scope.row.CO_Privilage == 2
												? '所有访问用户公开'
												: '私有'
										}}
									</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="状态" width="140">
								<template slot-scope="scope">
									<p
										class="scopefont"
										:style="{ 'background-color': scope.row.CO_CoursesState !== 4 ? (scope.row.CO_CoursesState == 0 ? '#f2be54' : '#E74C3C') : '#67c23a' }"
										style="text-align: center;"
									>
										{{ scope.row.CO_CoursesState == 4 ? '审核通过' : scope.row.CO_CoursesState == 0 ? '待审核' : '审核未通过' }}
									</p>
								</template>
							</el-table-column>
							<el-table-column :resizable="false" label="上下架" width="100px">
								<template slot-scope="scope">
									<p class="scopefont" style="text-align: center;" :style="{ 'background-color': scope.row.CO_OnOrOff == 1 ? '#67c23a' : '#E74C3C' }">
										{{ scope.row.CO_OnOrOff == 1 ? '已上架' : '已下架' }}
									</p>
								</template>
							</el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="300px">
								<template slot-scope="scope">
									<div style="text-align: center;">
										<el-button size="mini" style="background-color: #409eff;" @click="gocoursedetil(scope.row)">预览</el-button>

										<el-popconfirm title="确认审核显示该课程" @confirm="confirmcouse(scope.row)" v-if="scope.row.CO_CoursesState == 0">
											<el-button v-if="isusersshow" slot="reference" size="mini" style="background-color: #F39C12;margin: 0 5px;">审核</el-button>
										</el-popconfirm>
										<el-popconfirm
											title="是否将该课程设置为推荐课程"
											@confirm="chengemcouse(2, scope.row)"
											v-if="scope.row.CO_CoursesState == 4 && scope.row.CO_CreationTimeTag == 0"
										>
											<el-button slot="reference" size="mini" style="background-color: #2ECC71;margin: 5px 0;">是否推荐</el-button>
										</el-popconfirm>
										<el-popconfirm
											title="是否将该课程设置最热课程"
											@confirm="chengemcouse(0, scope.row)"
											v-if="scope.row.CO_CoursesState == 4 && scope.row.CO_IsHot == 0"
										>
											<el-button slot="reference" size="mini" style="background-color: #2ECC71;margin: 5px 2px;">是否最热</el-button>
										</el-popconfirm>
										<el-popconfirm
											title="是否将该课程设置最新课程"
											@confirm="chengemcouse(1, scope.row)"
											v-if="scope.row.CO_CoursesState == 4 && scope.row.CO_IsNew == 0"
										>
											<el-button slot="reference" size="mini" style="background-color: #2ECC71;margin: 5px 2px;">是否最新</el-button>
										</el-popconfirm>
										<el-button v-if="scope.row.CO_OnOrOff == 0" size="mini" style="background-color: #3498DB;margin: 5px 0;" @click="geteditcourse(scope.row)">
											编辑
										</el-button>

										<el-popconfirm
											v-if="scope.row.CO_CoursesState == 4"
											:title="scope.row.CO_OnOrOff == 1 ? '是否下架' : '是否上架'"
											@confirm="chengesxj(scope.row)"
										>
											<el-button slot="reference" size="mini" style="margin: 5px 2px;background-color: #9B59B6;">
												{{ scope.row.CO_OnOrOff == 1 ? '下架' : '上架' }}
											</el-button>
										</el-popconfirm>
										<el-popconfirm title="是否删除该课程" @confirm="deletecourse(scope.row)">
											<el-button slot="reference" size="mini" style="background-color: #E74C3C;">删除</el-button>
										</el-popconfirm>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import {
	getGetCourseList,
	changeAuditCousers,
	changeMarkasRecommended,
	changeOffshelfCousers,
	changeOffEnableCousers,
	changeDeleteCousers
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { changedateString } from '@/utils/utils.js';
import AppOptions from '@/config/AppOptions.vue';
import $ from 'jquery';

export default {
	data() {
		return {
			value1: '',
			// 标题
			paths: [
				{
					path: '/homesview/examinationmanage/examinationmanage',
					name: '课程管理'
				}
			],
			tabsnum: 10,
			totalall: 0,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				CategoryID: '', // 类别
				ProfessionalID: '', //专业
				PR_GUID: '', //岗位
				CourseName: '', //课程名称
				Inspectionlevel: '', //等级
				StartTime: '',
				EndTime: ''
			},
			tabsnun: 1,
			tableData: [],
			powershowobj: {},
			isusersshow: false
		};
	},
	components: {
		titles
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		if (AppOptions.appEmpty) {
			let homestop = $(this.$refs.homes).offset().top;
			let homesleft = $(this.$refs.homes).offset().left;
			if (homestop < 25 && localStorage.getItem('token') && homesleft < 200) {
				// console.log("刷新页面")
				// if (localStorage.getItem('token')) {
				// 	window.location.reload();
				// }
			}
		}

		this.init();
		// console.log(window.sessionStorage.getItem("allbtnlist"))
	},
	methods: {
		getqxlis() {
			let powerlist = JSON.parse(window.sessionStorage.getItem('allbtnlist'));
			if (!powerlist) {
				powerlist = window.sessionStorage.getItem('allbtnlist');
			}
			this.powershowobj.powershows = powerlist;
			this.powershowobj.routers = this.$route.path;

			for (var i = 0; i < this.powershowobj.powershows.length; i++) {
				if (this.powershowobj.powershows[i].path == this.powershowobj.routers && this.powershowobj.powershows[i].title == '审核') {
					this.isusersshow = true;

					return;
				} else {
					this.isusersshow = false;
				}
			}
		},

		init() {
			this.getqxlis();
			this.gettableData();
		},
		changetablesize() {
			this.pagesobj.pageIndex = 1;
			this.pagesobj.pageSize = this.tabsnun;
			this.gettableData();
		},
		deletecourse(itm) {
			let COobj = {
				CO_GUID: itm.CO_GUID
			};
			changeDeleteCousers(COobj).then(res => {
				if (res.data.code > 0) {
					this.gettableData();
					this.$message.success(res.data.msg);
				}
			});
		},
		gocoursedetil(itm) {
			this.$router.push('/course/cours/clouddeteamange?coguid=' + itm.CO_GUID);
			// /course/cours/clouddeteamange?coguid=d27cf2f920c94174aac8bb2c165cfd7e
		},
		// 前往编辑页面
		geteditcourse(itm) {
			this.$router.push('/course/cours/editcourse?coguid=' + itm.CO_GUID);
		},

		// 审核，最热最新推荐
		confirmcouse(itm) {
			let data = {
				CO_GUID: itm.CO_GUID
			};

			changeAuditCousers(data).then(res => {
				if (res.data.code > 0) {
					this.gettableData();
					this.$message.success(res.data.msg);
				}
			});
		},
		chengemcouse(i, itm) {
			let COobj = {
				CO_GUID: itm.CO_GUID,
				Type: i
			};
			// console.log(COobj)
			changeMarkasRecommended(COobj).then(res => {
				if (res.data.code > 0) {
					this.gettableData();
					this.$message.success(res.data.msg);
				}
			});
		},
		chengesxj(itm) {
			// 上下架
			let data = {
				CO_GUID: itm.CO_GUID
			};
			if (itm.CO_OnOrOff == 1) {
				changeOffshelfCousers(data).then(res => {
					if (res.data.code > 0) {
						this.gettableData();
						this.$message.success(res.data.msg);
					}
				});
			} else {
				changeOffEnableCousers(data).then(res => {
					if (res.data.code > 0) {
						this.gettableData();
						this.$message.success(res.data.msg);
					}
				});
			}
		},

		getname() {
			this.pagesobj.CourseName = this.input;

			if (this.value1 != '') {
				this.pagesobj.StartTime = changedateString(this.value1[0]).hasTime;
				this.pagesobj.EndTime = changedateString(this.value1[1]).hasTime;
			}
			// console.log(this.pagesobj)
			this.gettableData();
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			// console.log(val);
			this.pagesobj.pageIndex = val;
			this.gettableData();
		},
		gettableData() {
			getGetCourseList(this.pagesobj).then(res => {
				// console.log(res)
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;
			});
		}
	}
};
</script>
